import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { pctChange } from "./headlineTotals";

export const ComparisonBadge = ({ current, previous, testId, label = "vs previous period" }) => {
  const pct = pctChange(current, previous);
  if (pct == null) return null;
  const flat = Math.abs(pct) < 1;
  const up = pct > 0;
  const Icon = flat ? Minus : up ? ArrowUpRight : ArrowDownRight;
  const tone = flat
    ? "bg-white/10 text-slate-200 ring-white/15"
    : up
      ? "bg-lime-400/15 text-lime-300 ring-lime-400/30"
      : "bg-amber-400/15 text-amber-300 ring-amber-400/30";
  const text = flat ? "Holding steady" : `${up ? "+" : ""}${pct.toFixed(0)}%`;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold ring-1 ${tone}`}
      data-testid={testId}
      title={`Previous period: ${Math.round(previous).toLocaleString()}`}
    >
      <Icon className="w-3 h-3" />
      {text} <span className="font-normal opacity-80">{label}</span>
    </span>
  );
};
